import React, { useCallback } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import EditItemModal from 'components/Modals/EditItemModal';
import useAPI from 'services/useAPI';
import Tl from 'localization/LocalizationKeys';
import ModelType from 'components/Model/ModelType';
import { useTranslation } from 'localization/useTranslation';
import _ from 'lodash';
import { privileges } from 'utils/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import createMutationRequest from 'utils/createMutationRequest';
import { treeKeys } from 'components/GraphTree/queries';
import { useOrgIdSelect } from 'components/Select/useOrgIdSelect';

const initalTreeState = {
  displayName: '',
  description: '',
  organization: null,
  parentId: null
};


const models = [
  {
    type: ModelType.TEXT,
    label: Tl.common.displayname,
    path: 'displayName',
    placeholder: Tl.admin.trees.createTree.placeholder,
    isRequired: true,
    hasError: _.isEmpty
  },
  {
    type: ModelType.TEXTAREA,
    label: Tl.common.description,
    path: 'description'
  },
  {
    type: ModelType.ORG_ID,
    label: Tl.common.organization,
    path: 'organization',
    properties: {
      neededPrivilege: privileges.TreeManagement
    }
  }
];


const NewTreeRoot = ({ isOpen, onCancel }) => {
  const [root, setRoot] = useState(null);
  const T = useTranslation();
  const api = useAPI();
  const queryClient = useQueryClient();
  const history = useHistory();
  const { currentOrg } = useOrgIdSelect({ onChange: null, neededPrivilege: privileges.TreeManagement });


  const createTree = useMutation({
    mutationFn: createMutationRequest(api.core.createNode),
    onMutate: (node) => {
      const oldData = queryClient.getQueryData(treeKeys.trees());
      queryClient.setQueryData(treeKeys.trees(), (old) => {
        return [...old, node];
      });
      return oldData;
    },
    onSuccess: (node) => {
      queryClient.invalidateQueries(treeKeys.trees());
      history.push(`/admin/trees/${node.id}`);

    },
    onError: (unusedError, unusedVariables, context) => {
      queryClient.setQueryData(treeKeys.trees(), context);
    }
  });

  const _onSave = useCallback(() => {
    createTree.mutate({ displayName: root.displayName, description: root.description, organizationId: root.organization.id });
  }, [createTree, root?.description, root?.displayName, root?.organization?.id]);

  return (
    <>
      <EditItemModal
        isOpen={isOpen}
        isLoading={createTree.isLoading}
        title={T.admin.createTree.title}
        onSave={_onSave}
        onCancel={onCancel}
        item={root ?? { ...initalTreeState, organization: currentOrg }}
        setItem={setRoot}
        models={models}
      />
    </>
  );
};

export default NewTreeRoot;
